export default (axios) => ({
    create: (data) => axios.post('u/contacts?origin=benhvien16a.com', data).then((_) => _.data),
});
